module.exports = __webpack_public_path__ + "img/calendar_icon@2x.6665e043.png";